import React from 'react';
import PropTypes from 'prop-types';
import ScrollAvatar from '../ScrollAvatar';
import { WrapperAvatarEdition, FormAvatarOW } from './style';

const AvatarEdition = ({
  className,
  dataFormAvatar,
  edit,
  changeView,
  changeImg,
  getAvatar,
  setAvatar,
  getDiametre,
  setImage,
  avatar,
  setImageResult,
  user,
  isFormat
}) => (
  <div>
    <WrapperAvatarEdition className={className}>
      <FormAvatarOW
        dataFormAvatar={dataFormAvatar}
        edit={edit}
        changeView={vw => changeView(vw)}
        changeImg={changeImg}
        getDiametre={getDiametre}
        setAvatar={setAvatar}
        setImage={setImage}
        avatar={avatar}
        setImageResult={setImageResult}
        avatarPhoto={user.avatarPhoto}
        user={user}
        isFormat={isFormat}
      />
      {!changeImg && <ScrollAvatar getAvatar={avatar => getAvatar(avatar)} />}
    </WrapperAvatarEdition>
  </div>
);

AvatarEdition.propTypes = {
  changeView: PropTypes.func,
  setImage: PropTypes.func,
  getAvatar: PropTypes.func,
  setAvatar: PropTypes.func,
  avatar: PropTypes.string,
  getDiametre: PropTypes.func,
  changeImg: PropTypes.bool,
  className: PropTypes.string,
  dataFormAvatar: PropTypes.shape({
    userName: PropTypes.string,
    type: PropTypes.string,
    perfil: PropTypes.string
  }),
  setImageResult: PropTypes.bool
};

export default AvatarEdition;
